// js/sections/FooterSection.js

class FooterSection extends HTMLElement {
  constructor() {
    super();
    // Locale + currency pickers use <dialog class="modal modal--popover">
    // wired by assets/value-picker-dialog.js — no per-instance JS needed.
  }
  connectedCallback() {
    this._setupCookiePrefs();
  }
  _setupCookiePrefs() {
    const btn = this.querySelector('[data-action="open-cookie-prefs"]');
    if (!btn) return;
    btn.addEventListener("click", () => {
      const api = window.privacyBanner || window.Shopify?.customerPrivacy;
      if (api?.showPreferences) api.showPreferences();
      else if (api?.showPreferencesDialog) api.showPreferencesDialog();
    });
  }
}
if (!window.customElements.get("cos-footer")) window.customElements.define("cos-footer", FooterSection);
